import { render } from "./LifeInsurance.vue?vue&type=template&id=3406eb5a&scoped=true"
import script from "./LifeInsurance.vue?vue&type=script&lang=js"
export * from "./LifeInsurance.vue?vue&type=script&lang=js"

import "./LifeInsurance.vue?vue&type=style&index=0&id=3406eb5a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3406eb5a"]])

export default __exports__